export const productKeys = {
  byId: (id: string) => ['product-by-id', id] as const,
};
